export default __webpack_public_path__ + "static/ar-600ed1a2adac096571f07660a995db9e.svg";